import { render, staticRenderFns } from "./mainbook.vue?vue&type=template&id=76778da8"
import script from "./mainbook.vue?vue&type=script&lang=js"
export * from "./mainbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports